import * as React from "react";
import { SNAPSHOT_GRID_LOAD_MORE_ROOT_MARGIN } from "@/modules/snapshots/grid/constants";

/**
 * Requests the next page when the sentinel (`loadMoreRef`) nears the bottom of the table scroller
 * (`tableScrollRef`). The observer is recreated whenever `enabled` flips, e.g. after each page finishes loading.
 */
export const useLoadMoreObserver = (enabled: boolean, onLoadMore: () => void) => {
  const loadMoreRef = React.useRef<HTMLDivElement | null>(null);
  const tableScrollRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    const target = loadMoreRef.current;
    const root = tableScrollRef.current;
    if (!target || !root || !enabled) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) onLoadMore();
      },
      { root, rootMargin: SNAPSHOT_GRID_LOAD_MORE_ROOT_MARGIN },
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [enabled, onLoadMore]);

  return { loadMoreRef, tableScrollRef };
};
